import { ObjectMapper } from 'json-object-mapper';
import { IModel } from 'services/models/IModel';
import { Model } from 'services/models/model';
import { ApprovalScopeItemModel } from './approval-scope-item.model';
import { SystemModuleType } from 'services/enums/SystemModuleType.enum';

export class ApprovalScopeModel extends Model implements IModel<ApprovalScopeModel> {
  name: string = '';
  description: string = '';
  openingInstructions: string = '';
  companyRootId: string = '';
  movementType: string = ''; // MovementType do backend (pode ser enum ou string)
  validateHeadcountPlanning: boolean = false;
  shiftChangeWithoutReplanCompanyIds: string[] = [];
  allowDifferentCostCenterChange: boolean = true;
  differentCostCenterChangeEmployeeIds: string[] = [];
  releaseOriginPositionOnCostCenterChange: boolean = false;
  isConfigured: boolean = false;
  approvalScopeItems: ApprovalScopeItemModel[] = [];
  source: string = '';
  companyRootName: string = '';

  get sourceData(): SystemModuleType {
    return SystemModuleType.getBy(this.source) as SystemModuleType;
  }

  get stepsBadge(): string {
    const count = this.approvalScopeItems?.length || 0;
    const className = count === 0 ? 'secondary' : 'success';
    return `<span class="badge bg-light-${className} text-wrap">${count}</span>`;
  }

  get statusBadge(): string {
    const statusMap = {
      false: {
        name: 'Não Configurado',
        color: 'secondary',
      },
      true: {
        name: 'Configurado',
        color: 'success',
      },
    };

    const statusKey = this.isConfigured.toString() as keyof typeof statusMap;
    const status = statusMap[statusKey] || statusMap['false'];

    return `<span class="badge bg-light-${status.color} text-wrap">${status.name}</span>`;
  }

  get updatedAt(): string {
    const dateValue = this.changeDate || this.creationDate || '';

    if (!dateValue) {
      return '';
    }

    if (String(dateValue).startsWith('0001-01-01')) {
      return '';
    }

    return dateValue;
  }

  static create(input: any): ApprovalScopeModel {
    if (!input) return new ApprovalScopeModel();

    const model = ObjectMapper.deserialize<ApprovalScopeModel>(ApprovalScopeModel, input);

    // Mapear os ApprovalScopeItems se existirem
    if (input.approvalScopeItems && Array.isArray(input.approvalScopeItems)) {
      model.approvalScopeItems = input.approvalScopeItems.map((item: any) =>
        ApprovalScopeItemModel.create(item)
      );
    }

    return model;
  }
}
